import bgImg from "@/assets/moment_bg_soccer.png";

export function TheMoment() {
  return (
    <section id="the-moment" className="relative overflow-hidden min-h-[85vh] flex items-center">
      <img
        src={bgImg}
        alt=""
        aria-hidden
        width={1920}
        height={1080}
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-background/60" />
      <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-background/30 to-background/80" />
      <div className="absolute inset-0 scan-lines opacity-30" />

      <div className="relative mx-auto max-w-5xl px-6 py-32 text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-primary mb-6">The Moment</p>
        <h2 className="font-display text-4xl sm:text-6xl lg:text-7xl leading-[1.02] max-w-4xl mx-auto">
          Every fan has imagined it.{" "}
          <span className="text-gradient-ember">ClutchCube makes it real.</span>
        </h2>
      </div>
    </section>
  );
}
